<template>
	<div class="wai">
		<div class="title">
			<div class="blue"></div>
			<div style="flex: 1;">运营计划管理</div>
		</div>
		<!-- 第二部分开始 -->
		<el-dialog title="添加标签" :visible.sync="dialogVisible" width="30%">
			<el-form label-width="90px">
				<el-form-item label="标签名称" required>
					<el-input style="width:280px;" v-model="labelname" size="medium" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 第二部分结束 -->
		<!-- 第三部分开始 -->
		<div style="margin-bottom: 20px; display: flex;">
			<div style="flex: 1;"><router-link to="newopera"><el-button size="small"
						type="primary">新建计划</el-button></router-link></div>
			<div style="display: flex;">
				<el-select style="width:120px;margin-right: 10px;" class="jul" size="small" v-model="filter.status"
					placeholder="请选择">
					<el-option v-for="item in storeval" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-input size="small" type="text" style="width: 180px;margin-right:10px;" v-model="filter.name"
					placeholder="请输入运营计划名称" />
				<el-button type="primary" @click="getlist" size="small">搜 索</el-button>
			</div>
		</div>
		<div>
			<el-table :header-cell-style="{'background-color':'#F9FCFF','text-align':'center'}"
				:cell-style="{'text-align':'center'}" :data="tableData" border style="width: 100%">
				<el-table-column prop="planName" label="计划名称">
				</el-table-column>
				<el-table-column prop="planCrowd" label="目标人群">
				</el-table-column>
				<el-table-column prop="planApproach" label="计划方式">
				</el-table-column>
				<el-table-column label="计划时间">
					<template slot-scope="scope">
						{{scope.row.planTime?scope.row.planTime:"/"}}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态">
				</el-table-column>
				<el-table-column align="center" prop="totalmoney" label="操作">
					<template slot-scope="scope">
						<div style="display:flex;width: 80px;margin: auto;" v-if="scope.row.status=='运营中'">
							<el-button type="text" style="flex: 1;" @click="deit(scope.row.id)">编辑</el-button>
							<el-button type="text" style="flex: 1;" @click="stops(scope.row.id)">停止</el-button>
						</div>
						<div style="display:flex;width: 80px;margin: auto;" v-else>
							<el-button type="text" style="flex: 1;" @click="upper(scope.row.id)">上架</el-button>
							<el-button type="text" style="flex: 1;" @click="deletes(scope.row.id)">
								<span style="color: red;">删除</span>
							</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 第三部分结束 -->

	</div>
</template>
<script>
	export default {
		data() {
			return {
				filter: {
					name: "",
					status: ""
				},
				// 优惠券包的筛选
				timeVal: "",
				radio: "",
				dialogVisible: false,
				labelname: "",
				//第三部分表格
				tableData: [],
				storeval: [{
						label: "全部状态",
						value: "",
					},
					{
						label: "下架中",
						value: 0,
					},
					{
						label: "运营中",
						value: 1,
					},
				]
			}
		},
		mounted() {
			this.getlist()
		},
		methods: {
			// 停止
			stops(id) {
				this.$http.get("dUserOperate/stop?id=" + id).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("停止成功")
						this.getlist()
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			//编辑
			deit(id) {
				this.$router.push({
					path: 'newopera',
					query: {
						id: id
					}
				})
			},
			// 上架
			upper(id) {
				this.$http.get("dUserOperate/grounding?id=" + id).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("上架成功")
						this.getlist()
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			// 删除
			deletes(id) {
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get("dUserOperate/delete?id=" + id).then(function(res) {
						if (res.body.code == 200) {
							this.$message.success("删除成功")
							this.getlist()
						}
					}, function(err) {
						this.$message.error("请求失败")
					})
				}).catch(() => {

				});

			},
			getlist() {
				if (this.filter.status) {
					this.filter.status = Number(this.filter.status)
				}
				console.log(this.filter)
				this.$http.get("dUserOperate/list?status=" + this.filter.status + "&name=" + this.filter.name).then(
					function(res) {
						console.log(res)
						if (res.body.code == 200) {
							this.tableData = res.body.data
						}
					},
					function(err) {
						this.$message.error("请求失败")
					})
			},
			claer() {
				this.$confirm('是否要删除该标签?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		}
	};
</script>
<style lang="less" scoped>
	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	// 第二部分
	.demo2 {
		box-sizing: border-box;
		width: 100%;
		padding: 20px;
		padding-top: 10px;
		min-height: 150px;
		display: flex;
		flex-wrap: wrap;
		border: 1px solid #D3D3D3;

		.demo2_label {
			cursor: pointer;
			height: 23px;
			margin-top: 10px;
			padding: 10px;
			background: #FFFFFF;
			border: 1px solid #D3D3D3;
			position: relative;

			& {
				margin-right: 20px;
			}

			&:hover div {
				display: block;
			}

			div {
				display: none;
				text-align: center;
				line-height: 12px;
				font-size: 12px;
				color: #FFFFFF;
				border-radius: 50%;
				position: absolute;
				right: -5px;
				top: -5px;
				height: 15px;
				width: 15px;
				background-color: #000000;
			}
		}

		.demo2_add {
			height: 23px;
			margin-top: 10px;
			cursor: pointer;
			padding: 10px;
			background: #FFFFFF;
			border: 1px dashed #D3D3D3;
		}
	}

	// <div class="demo2">
	// 		   <div class="demo2_label">
	// 			   付费用户
	// 			   <div>x</div>
	// 		   </div>
	// 		   <div class="demo2_add">
	// 			   付费用户
	// 			   <div>x</div>
	// 		   </div>
	// </div>
</style>